export default __webpack_public_path__ + "static/media/industry-ico.e538e87b.svg";